export default {
  full_menu: 'Volledig menu',
  free: 'GRATIS',
};
